import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { ShopProvider } from "./store/ShopContext";
import { AuthProvider } from "./store/AuthContext";
import CartDrawer from "./components/feature/CartDrawer";
import ToastHost from "./components/feature/ToastHost";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AuthProvider>
          <ShopProvider>
            <AppRoutes />
            <CartDrawer />
            <ToastHost />
          </ShopProvider>
        </AuthProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;